// extracted by mini-css-extract-plugin
module.exports = {"industry":"IndustryCard_industry__gRD5x","imageWrapper":"IndustryCard_imageWrapper__RpN_w","image":"IndustryCard_image__AZfx2","title":"IndustryCard_title__MORP8"};